import { Fragment } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ForgotPasswordModifyPage from "src/Pages/Auth/ForgotPasswordModifyPage";
import ForgotPasswordVerifyPage from "src/Pages/Auth/ForgotPasswordVerifyPage";
import LoginPage from "src/Pages/Auth/LoginPage";
import RegisterPage from "src/Pages/Auth/RegisterPage";
import RegisterPagePassword from "src/Pages/Auth/RegisterPagePassword";
import RegisterPageToken from "src/Pages/Auth/RegisterPageToken";
import CheckoutPage from "src/Pages/Checkout/CheckoutPage";
import PreCheckoutPage from "src/Pages/Checkout/PreCheckoutPage";
import TermsPage from "src/Pages/Terms/TermsPage";
import MiddlewareAuthRoute from "./MiddlewareAuthRoute";
import MiddlewareTermsRoute from "./MiddlewareTermsRoute";
import { guestRoutes } from "./GuestRoutes";
import { ReduxDataKey } from "src/base/store/store";
import { useSelector } from "react-redux";
import Layout from "../Layout/Layout";
import MainRouter from "./MainRouter";
import FormsPublicPage from "src/Pages/Forms/FormsPublicPage";
import FormPublicPage from "src/Pages/Forms/FormPublicPage";
import { cmsRoutes } from "./CMSRoutes";
import CMSContainer from "../Pages/CMS/CMSContainer";
import { Layout as LayoutType } from "src/base/store/layoutSlice";
import MiddlewareVersionRoute from "./MiddlewareVersionRoute";
import MultiCheckoutPage from "src/Pages/Checkout/MultiCheckoutPage";
import NotFound from "src/Pages/NotFound";
import MiddlewareExistRoute from "./MiddlewareExistRoute";
import { generalRoutes } from "./GeneralRoutes";
import { authRoutes } from "./AuthRoutes";
import IndexPage from "src/Pages/DashBoard/IndexPage";
import AuthWithProviders from "src/Pages/Auth/AuthWithProviders";

const Routers = () => {
  const ebsssLayout: LayoutType = useSelector((state) => state[ReduxDataKey.LAYOUT]);

  return (
    <Fragment>
      <BrowserRouter basename={"/"}>
        <Routes>
          <Route element={<AuthWithProviders />} path={process.env.PUBLIC_URL + "/auth/provider/:provider"} />
          <Route path={"/"} element={<MiddlewareVersionRoute />}>
            {generalRoutes.map(({ path, Component }, i) => (
              <Route element={Component} path={path} key={i} />
            ))}
            {guestRoutes.map(({ path, Component }, i) => (
              <Route element={<Layout hideLayout={false} children={undefined} classNames={undefined} />} key={i}>
                <Route element={Component} path={path} />
              </Route>
            ))}
            {ebsssLayout?.template && ebsssLayout?.template?.pages?.length > 0 ? (
              cmsRoutes(ebsssLayout?.template?.pages)?.map(({ path, Component }, i) => (
                <Route element={<CMSContainer hideLayout={false} children={undefined} classNames={undefined} />} key={i}>
                  <Route element={Component} path={path} />
                </Route>
              ))
            ) : generalRoutes
                .concat(guestRoutes)
                .concat(authRoutes)
                .every((r) => !window.location.pathname.startsWith(r.path)) ? (
              <Route element={<CMSContainer hideLayout={false} children={undefined} classNames={undefined} />} key={"cms"}>
                <Route element={<CMSContainer hideLayout={false} children={undefined} classNames={undefined} />} path={"/*"} />
              </Route>
            ) : (
              <></>
            )}
            <Route path={"/"} element={<MiddlewareAuthRoute />}>
              <Route path={"/"} element={<MiddlewareTermsRoute />}>
                <Route path={`/*`} element={<MainRouter />} />
              </Route>
            </Route>
          </Route>
          <Route path={`${process.env.PUBLIC_URL}/404`} element={<NotFound />} />
          {ebsssLayout?.commonAppSettings?.crm_v2_default_homepage ? (
            <Route element={<Layout hideLayout={false} children={undefined} classNames={undefined} horizontalMenu />}>
              <Route element={<IndexPage />} path={`${process.env.PUBLIC_URL}`} />
            </Route>
          ) : (
            <></>
          )}
          <Route path={`*`} element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </Fragment>
  );
};
export default Routers;
